import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Input, Space, message, Popconfirm } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import PageHeader from "../../components/ui/PageHeader";
import PageTransition from "../../components/ui/PageTransition";
import EmptyState from "../../components/ui/EmptyState";

const Roles = () => {
  const { request } = useRequest();
  const [roles, setRoles] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form] = Form.useForm();

  const fetchRoles = () => {
    request({ url: apiPath.roles, method: "GET", onSuccess: (res) => setRoles(res?.data?.data || []) });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fetchRoles, []);

  const openCreate = () => {
    setEditing(null);
    form.resetFields();
    setModalOpen(true);
  };

  const openEdit = (record) => {
    setEditing(record);
    form.setFieldsValue(record);
    setModalOpen(true);
  };

  const onSubmit = () => {
    form.validateFields().then((values) => {
      const url = editing ? `${apiPath.roles}/${editing._id}` : apiPath.roles;
      const method = editing ? "PUT" : "POST";
      request({
        url,
        method,
        data: values,
        onSuccess: () => {
          message.success(editing ? "Role updated" : "Role created");
          setModalOpen(false);
          fetchRoles();
        },
      });
    });
  };

  const onDelete = (record) => {
    request({
      url: `${apiPath.roles}/${record._id}`,
      method: "DELETE",
      onSuccess: () => {
        message.success("Role deleted");
        fetchRoles();
      },
    });
  };

  const columns = [
    { title: "Name", dataIndex: "name" },
    { title: "Description", dataIndex: "description" },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Button icon={<EditOutlined />} size="small" onClick={() => openEdit(record)} />
          <Popconfirm title="Delete this role?" onConfirm={() => onDelete(record)}>
            <Button icon={<DeleteOutlined />} size="small" danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <PageTransition>
      <PageHeader
        title="Roles"
        subtitle="Define roles employees can be assigned to"
        actions={
          <Button type="primary" icon={<PlusOutlined />} onClick={openCreate}>
            Add Role
          </Button>
        }
      />
      <Table
        rowKey="_id"
        columns={columns}
        dataSource={roles}
        pagination={{ pageSize: 10 }}
        locale={{ emptyText: <EmptyState message="No roles yet" actionLabel="Add Role" onAction={openCreate} /> }}
      />

      <Modal title={editing ? "Edit Role" : "Add Role"} open={modalOpen} onCancel={() => setModalOpen(false)} onOk={onSubmit} destroyOnClose>
        <Form layout="vertical" form={form}>
          <Form.Item name="name" label="Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="description" label="Description">
            <Input.TextArea rows={3} />
          </Form.Item>
        </Form>
      </Modal>
    </PageTransition>
  );
};

export default Roles;
